import * as yup from "yup";
import Translate from "../../../../translation/utils/translateFunction";
import { validateMobileSchema } from "../../../../common/Utils/commonFunction";

export const AddGeneralManagerSchema = () => {
  const schema = yup.object().shape({
    companyId: yup
      .array()
      .of(yup.string().trim())
      .required(Translate("addManager:companyError"))
      .min(1, Translate("addManager:companyError")),

    name: yup.string().trim().required(Translate("addManager:gmNameError")),
    dob: yup.string().trim().required(Translate("addManager:dobError")),
    designation: yup
      .string()
      .trim()
      .required(Translate("addManager:designationError")),
    department: yup
      .string()
      .trim()
      .required(Translate("addManager:departmentError")),
    ...validateMobileSchema("mobile", Translate("addManager:numberError_2")),
    reportTo: yup.string().trim().required(Translate("addTask:reportToError")),
    email: yup
      .string()
      .email(Translate("addManager:workEmailError"))
      .trim()
      .required(Translate("addManager:workEmailError_1"))
      .test(
        "is-lowercase",
        Translate("common:lowerCaseWorkemailError"),
        (value) => {
          if (!value) return true;
          return value === value.toLowerCase();
        }
      ),
    resAddress: yup
      .string()
      .trim()
      .required(Translate("addManager:addressError")),
    resCountry: yup
      .string()
      .trim()
      .required(Translate("addManager:countryError")),
    resState: yup.string().trim().required(Translate("addManager:stateError")),

    workCountry: yup
      .string()
      .trim()
      .required(Translate("addManager:countryError")),
    workState: yup.string().trim().required(Translate("addManager:stateError")),
    workAddress: yup
      .string()
      .trim()
      .required(Translate("addManager:workAddressError")),
  });

  return schema;
};
